import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { reactive } from "vue";
import CardWrap from "@/components/common/CardWrap.vue";
import CardHeader from "./CardHeader.vue";
import CardTab from "./CardTab.vue";
import CardContractInfo from "./CardContractInfo.vue";
import CardInvoiceInfo from "./CardInvoiceInfo.vue";
import CardInvoiceTable from "./CardInvoiceTable.vue";
import CardFooter from "./CardFooter.vue";
import { ICompanyInvoice } from "@/models/company-invoice";

interface IProps {
  companyInvoice: ICompanyInvoice;
  remainCompanyInvoices: ICompanyInvoice[];
}
export type IDisplayContent = "contractInfo" | "invoiceInfo";


export default /*#__PURE__*/_defineComponent({
  __name: 'Card',
  props: {
    companyInvoice: {},
    remainCompanyInvoices: {}
  },
  setup(__props: any) {



const state: {
  mode: IDisplayContent;
} = reactive({
  mode: "contractInfo",
});

const changeMode = (mode: IDisplayContent) => {
  console.log(mode);
  state.mode = mode;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(CardWrap, { class: "card-wrap" }, {
      default: _withCtx(() => [
        _createVNode(CardHeader, {
          "company-invoice": _ctx.companyInvoice,
          "remain-company-invoices": _ctx.remainCompanyInvoices
        }, null, 8, ["company-invoice", "remain-company-invoices"]),
        _createVNode(CardTab, {
          mode: state.mode,
          "change-mode": changeMode
        }, null, 8, ["mode"]),
        (state.mode === 'contractInfo')
          ? (_openBlock(), _createBlock(CardContractInfo, {
              key: 0,
              "company-invoice": _ctx.companyInvoice
            }, null, 8, ["company-invoice"]))
          : _createCommentVNode("", true),
        (state.mode === 'invoiceInfo')
          ? (_openBlock(), _createBlock(CardInvoiceInfo, {
              key: 1,
              "company-invoice": _ctx.companyInvoice
            }, null, 8, ["company-invoice"]))
          : _createCommentVNode("", true),
        (state.mode === 'invoiceInfo')
          ? (_openBlock(), _createBlock(CardInvoiceTable, {
              key: 2,
              "company-invoice": _ctx.companyInvoice
            }, null, 8, ["company-invoice"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(CardFooter, { "company-invoice": _ctx.companyInvoice }, null, 8, ["company-invoice"])
  ], 64))
}
}

})